export default "__VITE_ASSET__CH2gaOlI__"